import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react";

import { useLocation } from "react-router-dom";


import {
    getUserAccess,
    setUserProfile,
} from "../../services/utils";
import { useGetUserProfileMutation } from "../Layout/Api";


const UserAccessContext = createContext(null);


export const UserAccessProvider = ({ children }) => {

    const location = useLocation();

    const [userAccess, setUserAccess] = useState(getUserAccess());

    const [isAccessLoaded, setIsAccessLoaded] = useState(false);


    const [getUserProfile] = useGetUserProfileMutation();


    const refreshUserAccess = useCallback(async () => {

        const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";


        if (!isLoggedIn) {

            setUserAccess([]);

            setIsAccessLoaded(true);

            return;
        }


        try {

            const response = await getUserProfile({}).unwrap();


            const latestUser = response?.data;


            const latestAccess = latestUser?.access;


            if (Array.isArray(latestAccess)) {

                setUserAccess(latestAccess);


                const storedUser =
                    JSON.parse(
                        localStorage.getItem("user") || "{}"
                    );


                setUserProfile({
                    ...storedUser,
                    ...latestUser,
                    access: latestAccess,
                });

            }

        } catch (error) {

            console.error("Failed to refresh user access:", error);

        } finally {

            setIsAccessLoaded(true);

        }

    }, [getUserProfile]);


    /*
     * Refresh access when:
     *
     * 1. Application loads
     * 2. User moves to another module
     */
    useEffect(() => {

        refreshUserAccess();

    }, [
        location.pathname,
        refreshUserAccess
    ]);


    /*
     * Refresh access when user
     * comes back to the browser tab.
     */
    // useEffect(() => {

    //     const handleFocus = () => {
    //         refreshUserAccess();
    //     };


    //     const handleVisibilityChange = () => {

    //         if (
    //             document.visibilityState === "visible"
    //         ) {
    //             refreshUserAccess();
    //         }

    //     };


    //     window.addEventListener(
    //         "focus",
    //         handleFocus
    //     );


    //     document.addEventListener(
    //         "visibilitychange",
    //         handleVisibilityChange
    //     );


    //     return () => {

    //         window.removeEventListener(
    //             "focus",
    //             handleFocus
    //         );


    //         document.removeEventListener(
    //             "visibilitychange",
    //             handleVisibilityChange
    //         );

    //     };

    // }, [refreshUserAccess]);


    const clearUserAccess = () => {

        setUserAccess([]);

    };


    return (
        <UserAccessContext.Provider
            value={{
                userAccess,
                setUserAccess,
                refreshUserAccess,
                clearUserAccess,
                isAccessLoaded,
            }}
        >
            {children}
        </UserAccessContext.Provider>
    );

};


export const useUserAccess = () => {

    const context =
        useContext(UserAccessContext);


    if (!context) {

        throw new Error(
            "useUserAccess must be used inside UserAccessProvider"
        );

    }


    return context;

};